import { jsxs as f, jsx as i } from "react/jsx-runtime";
import { Divider as p } from "./index.es24.js";
import { useEffect as n } from "react";
import u from "./index.es5587.js";
import { useCard as d } from "./index.es795.js";
import { FooterButtonGroup as C } from "./index.es5588.js";
import { FooterRightControls as l } from "./index.es5589.js";
import { FooterLeftControls as F } from "./index.es5590.js";
const r = ({ hasDivider: e, children: o, ref: m }) => {
  const { registerFooterId: t, footerId: s } = d();
  return n(() => {
    o && t();
  }, [o, t]), /* @__PURE__ */ f("div", { className: u.footer, ref: m, id: s, children: [
    e && /* @__PURE__ */ i(p, {}),
    o
  ] });
};
r.ButtonGroup = C;
r.RightControls = l;
r.LeftControls = F;
export {
  r as CardFooter
};
//# sourceMappingURL=index.es798.js.map
